import { c as _c } from "react/compiler-runtime";
import { useSelfieMachine } from '../../context/selfie-context';
import RetryView from './retry-view';
const Retry = () => {
  const $ = _c(7);
  const [state, dispatch] = useSelfieMachine();
  let t0;
  if ($[0] !== state.context.errors) {
    t0 = state.context.errors ?? [];
    $[0] = state.context.errors;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== dispatch) {
    t1 = () => dispatch({
      type: "retakeSelfie"
    });
    $[2] = dispatch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <RetryView errors={t0} onRetake={t1} />;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default Retry;